import { ArchiveFileSummary } from './archive-file-summary.model';
import { ArchiveKeepPeriodType } from './archive-keep-period-type.enum';
import { ArchiveSecretLevel } from './archive-secret-level.enum';
import { ArchiveSortRuleInfo } from './archive-sort-rule-info.model';
import { ArchiveStatus } from './archive-status.enum';
import { ArchiveVolumeCreateType } from './archive-volume-create-type.enum';
import { ArchiveVolumeFileRule } from './archive-volume-file-rule.enum';
import { ArchiveVolumePageType } from './archive-volume-page-type.enum';

export class ArchiveVolume extends ArchiveFileSummary {
  [key: string]: any;
  createType?: ArchiveVolumeCreateType = ArchiveVolumeCreateType.MANUAL;
  volumePageType?: ArchiveVolumePageType = ArchiveVolumePageType.UNLIMITED;
  volumePageLimit?: number;
  projectId?: number;
  sectionId?: number | string;
  dwPartSectionId?: number;
  dwTypeCode?: string;
  dwTypeName?: string;
  catalogId?: number;
  code?: string;
  codeSn?: number;
  seeAlsoCode?: string;
  name?: string;
  title?: string;
  startTime?: number;
  finishTime?: number;
  keepPeriodType?: ArchiveKeepPeriodType = ArchiveKeepPeriodType.PERMANENT;
  secretLevel?: ArchiveSecretLevel;
  createUnit?: string;
  sortRules?: Array<ArchiveSortRuleInfo>;
  fileRule?: ArchiveVolumeFileRule = ArchiveVolumeFileRule.NONE;
  fileFinishDateFrom?: number;
  fileFinishDateFromDate?: Date;
  fileFinishDateTo?: number;
  fileFinishDateToDate?: Date;
  sectionItemId?: number | string | null;
  sectionItemIds?: Array<string | number>;
  materialTypeId?: string | number;
  materialModelId?: number;
  materialYear?: string;
  status?: ArchiveStatus;
  allowVolumeTimeNull?: boolean;
  volumeTime?: number;
  volumeCode?: string;
  volumeRemark?: string;
  volumePrintedFileId?: string;
  volumePrintedNoPageFileId?: string;
  volumeFrontCoverFileId?: string;
  volumeSpineFileId?: string;
  volumeZipFileId?: string;
  sortOrder?: number;
  comment?: string;
  fileStatusComment?: string;
  // 前端自用
  selected?: boolean;
  sortOrderLabel?: string;
  sortOrderTarget?: number;
  isMaterial?: boolean;
}
